import {
    createContext,
    useContext
} from "react";
import type {
    PaginationContextType
} from "./type";

export const PAGINATION_PAGE_SIZE_OPTIONS: Array<number> = [
    10,
    20,
    50,
    100
];

export const PAGINATION_DEFAULT_PAGE_SIZE = 20;

export const PAGINATION_DEFAULT_CONTEXT: PaginationContextType = {
    pageSizeOptions: PAGINATION_PAGE_SIZE_OPTIONS,
    pageSize: PAGINATION_DEFAULT_PAGE_SIZE,
    onPageSizeChange: () => undefined,
    onPageChange: () => undefined,
    stepTitleBehaviour: "auto",
    variant: "numbered",
    isDisabled: false,
    boundaryCount: 1,
    isCompact: false,
    isLoading: false,
    siblingCount: 1,
    isError: false,
    size: "medium",
    page: 1
};

export const PaginationContext = createContext<PaginationContextType>(PAGINATION_DEFAULT_CONTEXT);

export const usePaginationContext = () => useContext(PaginationContext);
